module.exports = __webpack_public_path__ + "static/media/ilkley-18.eb1d5c56.jpg";